
import axios from 'axios'


function getRoute(id) {
    return axios.get(`${process.env.VUE_APP_APIURL}/route/${id}`).then(res => {
        return res.data
    })
}

function getRoutes() {
    return axios.get(`${process.env.VUE_APP_APIURL}/route`).then(res => {
        return res.data
    })
}

function createRoute(route) {
    return axios.post(`${process.env.VUE_APP_APIURL}/route`, route).then(res => {
        return res.data
    })
}

function updateRoute(route) {
    return axios.put(`${process.env.VUE_APP_APIURL}/route/${route._id}`, route).then(res => {
        return res.data._id
    })
}

function deleteRoute(routeId) {
    return axios.delete(`${process.env.VUE_APP_APIURL}/route/${routeId}`).then(res => {
        return res.data
    })
}

export default {
    getRoute,
    getRoutes,
    createRoute,
    updateRoute,
    deleteRoute,
};